import { useEffect, useState } from "react";
import { StatusBadge } from "@/components/StatusBadge";
import { api, fmtDate, kina } from "@/lib/api";
import { RateRide } from "@/components/customer/ActiveRide";

export const MyRides = () => {
  const [rides, setRides] = useState(null);
  const load = () => api.get("/bookings/mine").then((r) => setRides(r.data)).catch(() => setRides([]));
  useEffect(() => {
    load();
  }, []);
  if (!rides) return <div className="h-64 animate-pulse rounded-2xl bg-white" />;
  if (!rides.length) return <p data-testid="no-rides-message" className="rounded-2xl border border-dashed border-blue-200 bg-white p-10 text-center text-slate-500">No rides yet. Book your first Comfort Taxi!</p>;
  return (
    <div className="space-y-3" data-testid="ride-history-list">
      {rides.map((r) => (
        <div key={r.id} data-testid={`ride-history-item-${r.id}`} className="rounded-2xl border border-blue-100 bg-white p-5 transition-shadow hover:shadow-lg hover:shadow-blue-900/5">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <div className="min-w-0 flex-1">
            <p className="text-xs text-slate-400">{r.scheduled_for ? `Scheduled for ${fmtDate(r.scheduled_for)}` : fmtDate(r.created_at)}</p>
            <p className="mt-1 truncate font-medium text-slate-900">{r.pickup.address} → {r.dropoff.address}</p>
            <p className="text-sm text-slate-500">{r.distance_km} km {r.driver_name ? `· ${r.driver_name}` : ""}</p>
          </div>
          <StatusBadge status={r.status} />
          <p className="font-mono-num text-lg font-semibold text-slate-900">{kina(r.fare)}</p>
          </div>
          {r.status === "completed" && r.driver_name && (
            <div className="mt-3 border-t border-slate-100 pt-3"><RateRide ride={r} onRated={load} /></div>
          )}
        </div>
      ))}
    </div>
  );
};
